import i18n from "@/plugins/i18n";
import { OBSERVABLE_UNITS } from "@/types/observableUnits";

export default {
  async list() {
    const observableUnitsValues = [
      {
        id: OBSERVABLE_UNITS.ALL,
        text: i18n.t("filters.include-all-units")
      },
      {
        id: OBSERVABLE_UNITS.OBSERVABLE_ONLY,
        text: i18n.t("filters.include-only-observable-units")
      }
    ];

    return new Promise((res) => res(observableUnitsValues));
  }
};
